import { RequestError } from '../requestError';
import api from '../axiosBase';
import { getURL } from '../serviceHelper';
import { getEnv } from '../../AppConfigs';
import { getEndDayOfYear, getStartDayOfYear, setUtcWithoutTime } from '../../helper/dateTimeHelper';

const SPSiteId = getEnv('REACT_APP_SP_SITE_ID');
const SPListId = getEnv('REACT_APP_LEAVE_REQUEST_SP_LIST_ID');

const expand = 'expand=fields(select=title,eLeaveStartDate,eLeaveEndDate,eDuration,eLeaveReason,ePreApprovedBy,ePreApprovedDate,eApprovedBy,eApprovedDate,ePreApprovalComment,eApprovalComment,ePreApproved,eApproved,eRquestStatus,eLeaveType)';
const start = getStartDayOfYear();
const end = getEndDayOfYear();

export class LeaveRequestService {

  static async getLeaveRequests(status?: string) {
    let filter = `filter=fields/eLeaveStartDate ge '${setUtcWithoutTime(start)}' and fields/eLeaveStartDate le '${setUtcWithoutTime(end)}'`;
    if (status) {
      filter += `and fields/eRquestStatus eq '${status}'`;
    }
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async getLeaveRequestsNeedMeApprove(email: string, status?: string) {
    let filter = `filter=((startswith(fields/eApprovedBy,'${email.toLowerCase()}') and fields/eApproved eq null) or (startswith(fields/ePreApprovedBy,'${email.toLowerCase()}') and fields/ePreApproved eq null)) and fields/eLeaveStartDate ge '${setUtcWithoutTime(start)}' and fields/eLeaveStartDate le '${setUtcWithoutTime(end)}'`;
    if (status) {
      filter += `and fields/eRquestStatus eq '${status}'`;
    }
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async getMyLeaveRequestsApprovalHistory(email: string) {
    let filter = `filter=(startswith(fields/eApprovedBy,'${email.toLowerCase()}') or startswith(fields/ePreApprovedBy,'${email.toLowerCase()}')) and fields/eLeaveStartDate ge '${setUtcWithoutTime(start)}' and fields/eLeaveStartDate le '${setUtcWithoutTime(end)}'`;
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async getMyLeaveRequests(email: string, status?: string) {
    let filter = `filter=fields/eLeaveStartDate ge '${setUtcWithoutTime(start)}' and fields/eLeaveStartDate le '${setUtcWithoutTime(end)}'`;
    if (status) {
      filter += `and fields/eRquestStatus eq '${status}'`;
    }
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}`))
      .then(res => res.data.value.filter((o: any) => o.createdBy.user.email.toLowerCase() === email.toLowerCase()))
      .catch(err => { throw new RequestError(err) });
  }

  static async getLeaveRequest(id: any) {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}?${expand}`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async addLeaveRequest(leaveRequest: any) {
    return api.post(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items`), leaveRequest)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async updateLeaveRequest(id: any, fields: any) {
    return api.patch(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/fields`), fields)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

}